import { useMutation } from "@tanstack/react-query";

import { createNewConsultationLink } from "~/providers/api/consultationLinks";

export const useCreateNewConsultationLink = () => {
  return useMutation({
    mutationFn: createNewConsultationLink,
  });
};
